<template>
  <div :id="$attrs['id']"
       :title="title"
       :class="[ $attrs['class'], 'inline-button', { 'inline-button--no-border': !border }, { 'inline-button--slot': isSlot }]"
       :disabled="disabled"
       @click="onClick">
    <icon :icon="icon" :color="iconColor" />
  </div>
</template>

<script>

import { startsWith } from 'lodash';

export default {
  name: 'InputIconButton',

  props: {
    title: {
      required: false,
      type: String,
      default: null,
    },
    icon: {
      required: true,
    },
    color: {
      required: false,
    },
    border: {
      required: false,
      default: true,
    },
    isSlot: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconColor: function () {
      return this.disabled ? '#f5f6f6' : this.color;
    },
  },

  methods: {
    onClick: function ($event) {
      if (!this.disabled) {
        this.$emit('click', $event);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .inline-button[disabled] {
    cursor: not-allowed;

    * {
      pointer-events: none;
    }
    /*
    background-color: $lightgray;
    border: 1px solid $middlegray;

    &:last-child {
      border-top-right-radius: 0.3rem;
      border-bottom-right-radius: 0.3rem;
    }
     */
  }

  .inline-button {
    &--slot {
      position: relative;
      max-height: 3.0rem!important;
      height: 100%!important;
      bottom: 0.1rem!important;
      top: 0.1rem!important;
      &:before {
        content: ' ';
        display: block;
        width: 100%!important;
        height: 100%!important;
        top: 0.0rem!important;
        position: absolute;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        background-image: url('~svg/switch.svg');
        pointer-events: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/InputIconButton.vue